export enum ErrorWebXR {
  UNDEFINED = 'UNDEFINED',
  NOT_SUPPPORTED = 'NOT_SUPPPORTED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
}